export const KEY_CODE = {
  LEFT: 37,
  RIGHT: 39,
  TAB: 9,
  BACKSPACE: 8
}

export const klass = {
  container: 'tags-input',
  input: 'input',
  gap: 'gap',
  tag: 'tag',
  placeholder: 'placeholder'
}



// WEBPACK FOOTER //
// ./src/lib.js